module.exports = __webpack_public_path__ + "img/GO-RAL-logo.7880c16b.png";